import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getHppRemoteWalletProviders } from 'services/HppSettingsService'

export const useHppRemoteWalletProvidersQuery = () =>
  useQuery({
    queryKey: reactQueryKeys.hppRemoteWalletProviders(),
    queryFn: getHppRemoteWalletProviders,
  })
